export default __webpack_public_path__ + "style.min.css";